import styled from 'styled-components';
import { SegmentedControl, SegmentedControlProps } from '@mantine/core';
import { GenericDrawer } from '@dealstack/frontend/shared/components/GenericDrawer/GenericDrawer';

export const StyledSecurityOverrideDrawer = styled(GenericDrawer)`
	.mantine-Drawer-header {
		padding-bottom: 0.5rem !important;
	}
`;

export const StyledSecurityOverride = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const SecurityOverrideCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.25rem;
	padding: 0.5rem;
`;

export const InfoBlockContainer = styled.div`
	display: flex;
	background-color: ${({ theme }) => theme.v3.colors.gray[0]};
	border-radius: 0.25rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
`;

export const InfoBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding: 0.5rem;

	&:not(:last-child) {
		border-right: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	}
`;

export const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`;

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;
	margin-top: auto;

	.mantine-Button-root {
		width: 100%;
	}
`;

export const OverrideModeSwitch = styled(SegmentedControl)<SegmentedControlProps>`
	width: 100%;
	background-color: ${({ theme }) => theme.color.white[500]};
	border: 1px solid ${({ theme }) => theme.color.greys[200]};

	.mantine-SegmentedControl-indicator {
		background-color: ${({ theme }) => theme.v3.colors.blue[0]};
		border: 1px solid ${({ theme }) => theme.v3.colors.blue[6]};
	}
`;
